import { SVGProps } from "react";

const ClientsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_750_1551)">
        <path
          d="M16.2188 5.90088H20.7286L15.5156 0.687866V5.19776C15.5156 5.58569 15.8308 5.90088 16.2188 5.90088Z"
          fill="#43454E"
        />
        <path
          d="M12.7031 11.5728H15.5156V12.979H12.7031V11.5728Z"
          fill="#43454E"
        />
        <path
          d="M12.7031 14.3853H15.5156V15.7915H12.7031V14.3853Z"
          fill="#43454E"
        />
        <path
          d="M8.48438 14.3853H11.2969V15.7915H8.48438V14.3853Z"
          fill="#43454E"
        />
        <path
          d="M12.7031 17.1978H15.5156V18.604H12.7031V17.1978Z"
          fill="#43454E"
        />
        <path
          d="M4.96875 24.2759H19.0312C20.1944 24.2759 21.1406 23.3297 21.1406 22.1665V7.30713H16.2188C15.0556 7.30713 14.1094 6.36091 14.1094 5.19775V0.275879H4.96875C3.80559 0.275879 2.85938 1.2221 2.85938 2.38525V22.1665C2.85938 23.3297 3.80559 24.2759 4.96875 24.2759ZM7.07812 10.8696C7.07812 10.481 7.39261 10.1665 7.78125 10.1665H16.2188C16.6074 10.1665 16.9219 10.481 16.9219 10.8696V19.3071C16.9219 19.6958 16.6074 20.0103 16.2188 20.0103H7.78125C7.39261 20.0103 7.07812 19.6958 7.07812 19.3071V10.8696Z"
          fill="#43454E"
        />
        <path
          d="M8.48438 17.1978H11.2969V18.604H8.48438V17.1978Z"
          fill="#43454E"
        />
        <path
          d="M8.48438 11.5728H11.2969V12.979H8.48438V11.5728Z"
          fill="#43454E"
        />
      </g>
      <defs>
        <clipPath id="clip0_750_1551">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.275879)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClientsIcon;
